<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="notice_detail">
      <div class="notice_content flex flexcolumn Flexalign">
        <div
          class="flex Flexalign cursor_pointer back_box FlexEnd FlexjustifyEnd"
          @click="back"
        >
          <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
          <div class="mar_left_10">返回</div>
        </div>
        <div class="notice_title">{{ noticeInfo.noticeTitle }}</div>
        <div class="notice_created flex Flexalign">
          <div>创建人：{{ noticeInfo.createByName }}</div>
          <div class="mar_left_40">发布时间：{{ noticeInfo.sendTime }}</div>
        </div>
        <div
          class="notice_content_box mar_top_30"
          v-html="noticeInfo.noticeContent"
        ></div>
      </div>
    </div>
    <moe-bottom></moe-bottom>
  </moe-page>
</template>

<script>
export default {
  name: "GjkcH5NoticeDetail",

  data() {
    return {
      noticeId: "",
      noticeInfo: {},
    };
  },

  mounted() {
    this.noticeId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).noticeId;
    this.getNoticeDetail();
  },

  methods: {
    getNoticeDetail() {
      this.$Api.course
        .getNoticeDetail(this.noticeId)
        .then((res) => {
          this.noticeInfo = res.data.data;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.notice_detail {
  width: 100%;
  background: #f3f3f3;
  .back_box {
    width: 100%;
    font-size: 18px;
    color: #13d6aa;

    .back_icon {
      width: 24px;
      height: 24px;
    }
  }
  .notice_content {
    width: 1200px;
    min-height: 716px;
    background: #ffffff;
    border-radius: 10px;
    margin: 30px auto;
    padding: 30px 20px;
    box-sizing: border-box;
    .notice_title {
      font-weight: 500;
      font-size: 22px;
      color: #111111;
      line-height: 38px;
    }
    .notice_created {
      color: #999999;
      line-height: 38px;
    }
    .notice_content_box {
      width: 100%;
    }
  }
}
</style>
